import React from 'react'
import PropTypes from 'prop-types'
import { PanelGroup, Panel, ListGroup, ListGroupItem } from 'react-bootstrap'
import isEmpty from 'lodash/isEmpty'
import { rest } from '../../lib'

class ServerWidget extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      servers: []
    }
  }

  componentDidMount() {
    this._isMounted = true
    this.fetchServers()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.reload) {
      this.fetchServers()
    }
  }

  componentWillUnmount = () => this._isMounted = false

  fetchServers = () => {
    rest.serverList().then((data) => {
      if (this._isMounted) this.setState({ servers: data.servers })
    })
  }

  renderChannel = (channels) => {
    return (
      <ListGroup fill>
        {
          (isEmpty(channels)) ?
          <ListGroupItem key={0}>No channel</ListGroupItem> :
          channels.map((ch, idx) => <ListGroupItem key={idx}>{ch.device + '.' + ch.id + ' > ' + ch.address}</ListGroupItem> )
        }
      </ListGroup>
    )
  }

  renderConnections = (connections) => {
    return (
      <ListGroup fill>
        {
          isEmpty(connections) ?
          <ListGroupItem key={0}>No connection</ListGroupItem> :
          connections.map((conn, idx) => <ListGroupItem key={idx}>{conn}</ListGroupItem> )
        }
      </ListGroup>
    )
  }

  renderNode = () => {
    const { servers } = this.state
    if (isEmpty(servers)) {
      return <Panel><div>No server running</div></Panel>
    }
    return servers.map((server, idx) => {
      return (
        <Panel key={idx} eventKey={idx}>
          <Panel.Heading><Panel.Title toggle>{server.id}</Panel.Title></Panel.Heading>
          <Panel.Body collapsible>
            { this.props.show === 'channel' ?
              this.renderChannel(server.channels) : this.renderConnections(server.connections)
            }
          </Panel.Body>
        </Panel>
      )
    })
  }

  render() {
    return (
      <PanelGroup id='collapsible-panels' accordion>
        {this.renderNode()}
      </PanelGroup>
    )
  }
}

ServerWidget.defaultProps = {
  reload: false,
  show: 'channel'
}

ServerWidget.propTypes = {
  reload: PropTypes.bool,
  show: PropTypes.string
}

export default ServerWidget



// WEBPACK FOOTER //
// ./src/components/widgets/ServerWidget.js